<div class="menu-wrap">
<div class="full-wrap">
<ul class="tab-menu pull-left">
<li class="ver-menu">
<a class="navbar-item" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a>
</li>
<li class="ver-menu">
<a class="navbar-item" routerLink="/inplay" routerLinkActive="active">In-Play</a>
</li>
<!-- -->
<li class="ver-menu">
<a class="navbar-item" routerLink="/multimarket" routerLinkActive="active">Multi Markets</a>
</li>
<!-- -->
<li class="ver-menu ng-star-inserted">
<a class="Virtual navbar-item" routerLink="/allsport-highlight/4" routerLinkActive="active"><!-- -->
                        Cricket</a>
</li>
<li class="ver-menu aviator ng-star-inserted">
<a class="Virtual navbar-item heartBeat" routerLink="/livecasino/2" routerLinkActive="active"><img class="aviatorImg ng-star-inserted" src="./../../../assets/casinoslpot/aviator.png"/><!-- -->
                        Vimaan</a>
</li>
<li class="ver-menu ng-star-inserted">
<a class="Virtual navbar-item" routerLink="/allsport-highlight/2" routerLinkActive="active"><!-- -->
                        Tennis</a>
</li>
<li class="ver-menu ng-star-inserted">
<a class="Virtual navbar-item" routerLink="/allsport-highlight/1" routerLinkActive="active"><!-- -->
                        Soccer</a>
</li>
<li class="ver-menu ng-star-inserted">
<a class="Virtual navbar-item" routerLink="/allsport-highlight/7" routerLinkActive="active"><!-- -->
                        Horse Racing</a>
</li>
<li class="ver-menu ng-star-inserted">
<a class="Virtual navbar-item newlaunch" routerLink="/allsport-highlight/10" routerLinkActive="active"><!-- -->
                        Politics</a>
</li>
<li class="ver-menu ng-star-inserted">
<a class="Virtual navbar-item" routerLink="/allsport-highlight/4339" routerLinkActive="active"><!-- -->
                        Greyhound Racing</a>
</li>
<li class="ver-menu ng-star-inserted">
<a class="Virtual navbar-item" routerLink="/allsport-highlight/7522" routerLinkActive="active"><!-- -->
                        Basketball</a>
</li>
<li class="ver-menu ng-star-inserted">
<a class="Virtual navbar-item" routerLink="/allsport-highlight/9" routerLinkActive="active"><!-- -->
                        Lottery</a>
</li>
<!-- --><!-- --><!-- --><!-- --><!-- -->
<li class="ver-menu">
<a class="navbar-item" routerLink="/livecasino/1" routerLinkActive="active">
                        Live Casino</a>
</li>
<!-- --><!-- --><!-- --><!-- -->
<li class="ver-menu">
<a class="navbar-item" routerLink="/tips" routerLinkActive="active">
                        Tips &amp; Previews</a>
</li>
<!-- --><!-- --><!-- --><!-- --><!-- -->
</ul>
<ul class="tab-menu pull-right">
<li class="ver-menu admin-nav-item">
  <a class="navbar-item admin-link" routerLink="/admin" routerLinkActive="active">
    🛡️ Admin Panel
  </a>
</li>
</ul>
<!-- -->
</div>
</div>
<br/><br/>